import { useState } from 'react';
/**
 * Show or hide a component based on a boolean prop, but wait for a transition to end before removing it from the React
 * tree/DOM. Useful when waiting for exit transitions like fading/sliding out.
 * @param shouldShow The boolean prop that controls whether the component should be shown.
 */
export function useUnmountOnTransitionEnd(shouldShow) {
    const [shouldRender, setShouldRender] = useState(shouldShow);
    if (shouldShow && !shouldRender) {
        setShouldRender(shouldShow);
    }
    return {
        shouldRender,
        unmountOnTransitionEnd: () => {
            if (!shouldShow) {
                setShouldRender(false);
            }
        },
    };
}
//# sourceMappingURL=useUnmountOnTransitionEnd.js.map